import ProfessionalCard from '@/components/professional/ProfessionalCard';
import { algoliaAnalytics } from '@/lib/search';
import { getUserID } from '@/lib/tracking';
import * as React from 'react';
import { connectHitInsights } from 'react-instantsearch-dom';

const ProfessionalHit = connectHitInsights(algoliaAnalytics)(
  ({ hit, insights, contactModal, requestQuoteModal }) => {
    // eslint-disable-next-line no-underscore-dangle
    const pathWithTracking = `${hit.path}?qid=${hit.__queryID}`;

    const trackClick = () => {
      try {
        insights('clickedObjectIDsAfterSearch', {
          eventName: 'Professional Clicked',
          userToken: getUserID(),
        });
      } catch {
        // ata ete n ai csf
      }
    };

    return (
      <ProfessionalCard
        professional={{
          ...hit,
          path: pathWithTracking,
        }}
        trackClick={trackClick}
        contactModal={contactModal}
        requestQuoteModal={requestQuoteModal}
        isSearchResult
      />
    );
  }
);

export default ProfessionalHit;
